import { useMemo } from 'react';
import { useSettingsQuery } from 'src/api/queries/userQueries';
import {
  AdminSettingsSection,
  Checkbox,
  PageBody,
  SaveChangesBar,
  SettingsNavigation,
} from 'src/components';

import styles from './styles.module.scss';
import { useAtom } from 'jotai';
import ReactSwitch from 'react-switch';
import { CustomImageConversions } from './components/CustomImageConversions';
import { imageSettingsAtom } from 'src/shared/settings/image';
import { ACTION_TYPES } from 'src/shared/settings/base';

export const ImageSettings = () => {
  const { isLoading } = useSettingsQuery();

  const [imageSettings, updateImageSettings] = useAtom(imageSettingsAtom);

  const deepzoom = useMemo(
    () => imageSettings?.conversions?.find((c: any) => c.key === 'deepzoom'),
    [imageSettings?.conversions],
  );

  const handleDeepzoomChange = (property: string, value: boolean) => {
    if (!deepzoom) return;
    updateImageSettings({
      type: ACTION_TYPES.UPDATE_STATE,
      payload: {
        conversions: {
          id: deepzoom.id,
          value: { [property]: value },
        },
      },
    });
  };

  if (isLoading) {
    return null;
  }

  return (
    <div className={styles.pageWrapper}>
      <SettingsNavigation />
      <SaveChangesBar />

      <PageBody narrow>
        <CustomImageConversions />

        {deepzoom && (
          <AdminSettingsSection title="Zoomable Image">
            <div className={styles.imageConvCardHeader}>
              <div className={styles.keyTitle}>
                <label>Key</label>
                <span className={styles.keyPill}>{deepzoom.key}</span>
              </div>
              <ReactSwitch
                checked={deepzoom.value.enabled}
                onChange={(checked: boolean) => handleDeepzoomChange('enabled', checked)}
                checkedIcon={false}
                uncheckedIcon={false}
                onColor="#2e53e3"
                width={40}
                height={20}
                handleDiameter={16}
              />
            </div>

            <div className={styles.imageConvCardBody}>
              <div className={styles.imageConvCardField}>
                <label>Size</label>
                <span className={styles.sizeBadge}>Original size</span>
              </div>
              <div className={styles.imageConvCardField}>
                <label>Watermark</label>
                <Checkbox
                  checked={deepzoom.value.watermark}
                  onChange={(e) => handleDeepzoomChange('watermark', e.target.checked)}
                />
              </div>
              <div className={styles.imageConvCardField}>
                <label>Public</label>
                <Checkbox
                  checked={deepzoom.value.public}
                  onChange={(e) => handleDeepzoomChange('public', e.target.checked)}
                />
              </div>
            </div>
          </AdminSettingsSection>
        )}
      </PageBody>
    </div>
  );
};
